module.exports = __webpack_public_path__ + "static/seguros-del-estado-52a02d4378875422a059db2b02a19991.png";